export default __webpack_public_path__ + "static/meta-8294219510e59eab64836148a518eb54.png";